// App.jsx
import React, { useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider, useAuth } from 'react-oidc-context';
import {isMaintenanceMode} from './utilities/constants.jsx';

import theme from './theme';
import { UserPoolClientId, HostedUIUrl, Authority } from './utilities/constants';

import LandingPage from './pages/LandingPage';
import BatchResultsPage from './pages/BatchResultsPage';
import BatchDetailPage from './pages/BatchDetailPage';

import MainApp from './MainApp';
import CallbackPage from './pages/CallbackPage';
import MaintenancePage from './pages/MaintenancePage';

const cognitoAuthConfig = {
  authority: `https://${Authority}`,
  client_id: UserPoolClientId,
  redirect_uri: `${HostedUIUrl}/callback`, // Amplify redirect_uri
  post_logout_redirect_uri: `${HostedUIUrl}/home`,
  // redirect_uri: 'http://localhost:3000/callback', // Local redirect_uri
  // post_logout_redirect_uri: 'http://localhost:3000/home',
  response_type: 'code',
  scope: 'email openid phone profile',
  loadUserInfo: false,
  automaticSilentRenew: false,
};

function ProtectedRoute({ children }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isAuthenticated) {
    sessionStorage.setItem('returnTo', location.pathname + location.search);
    return <Navigate to="/home" replace />;
  }

  return children;
}

function AppRoutes() {
  const auth = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  if (auth.isLoading) {
    return <div>Loading authentication status...</div>;
  }

  if (auth.error) {
    console.error('Authentication error:', auth.error);
    return <div>Authentication Error: {auth.error.message}</div>;
  }

  return (
    <Routes>
      {/* Landing / Public Routes */}
      <Route path="/home" element={<LandingPage />} />

      {/* Callback Route */}
      <Route path="/callback" element={<CallbackPage />} />

      {/* Protected App Routes */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <MainApp
              isLoggingOut={isLoggingOut}
              setIsLoggingOut={setIsLoggingOut}
            />
          </ProtectedRoute>
        }
      />

      {/* Batch Results Routes (protected) */}
      <Route
        path="/batch-results"
        element={
          <ProtectedRoute>
            <BatchResultsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/batch-results/:batchId"
        element={
          <ProtectedRoute>
            <BatchDetailPage />
          </ProtectedRoute>
        }
      />

      {/* Fallback: redirect unknown paths to /home */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider
      {...cognitoAuthConfig}
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      <ThemeProvider theme={theme}>
          {/* <AppRoutes /> */}
          {isMaintenanceMode ? <MaintenancePage /> : <AppRoutes />}
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
